var TabQuotationsModule = /** @class */ (function () {
    function TabQuotationsModule() {
    }
    return TabQuotationsModule;
}());
export { TabQuotationsModule };
